<template>
  <el-dialog
    title="添加资产"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      size="small"
      :model="formData"
      :rules="rules"
      ref="formData"
      v-loading="formLoading"
    >
      <!-- 固定格式 -->
      <el-form-item
        label="所属接口"
        :label-width="formLabelWidth"
        prop="other_plugin_name"
      >
        <el-autocomplete
          v-model="formData.other_plugin_name"
          :fetch-suggestions="queryTypeSearch"
          placeholder="请输入内容"
          placement="bottom"
          @change.native="handleTypeSelect"
          @select="handleTypeSelect"
        ></el-autocomplete>
      </el-form-item>

      <!-- <el-form-item
        :label="formData[1].text"
        :label-width="formLabelWidth"
        :key="formData[1].name"
        :prop="formData[1].name"
        v-show="formData[1].type === 'radio'"
      >
        <template v-if="formData[1].type === 'radio'">
          <el-radio-group v-model="formData[formData[1].name]">
            <el-radio
              v-for="option in formData[1].option"
              :key="option.value"
              :label="option.value"
              >{{ option.label }}</el-radio
            >
          </el-radio-group>
        </template>
      </el-form-item> -->

      <template v-if="formItems">
        <el-form-item
          v-for="item in formItems"
          :label="item.text"
          :label-width="formLabelWidth"
          :key="item.name"
          :prop="item.name"
          v-show="item.type === 'radio'"
        >
          <!-- <template v-if="item.type === 'input'">
            <el-input
              v-model="formData[item.name]"
              autocomplete="off"
              :placeholder="item.placeholder"
            ></el-input>
          </template> -->
          <!-- <template v-if="item.text === '资产类型'">
            <el-radio-group v-model="formData[item.name]">
              <el-radio
                v-for="option in item.option"
                :key="option.value"
                :label="option.value"
                >{{ option.label }}</el-radio
              >
            </el-radio-group>
          </template> -->
          <template  v-if="item.text === '资产类型'">
            <el-select v-model="formData[item.name]" placeholder="请选择">
              <el-option
                v-for="opt in item.option"
                :key="opt.value"
                :label="opt.label"
                :value="opt.value">
                {{ opt.label }}
              </el-option>
            </el-select>
          </template>
        </el-form-item>

        <el-form-item
          label="资产内容"
          :label-width="formLabelWidth"
          prop="other_plugin_name"
        >
          <el-input
            type="textarea"
            placeholder="请输入内容"
            v-model="assets_text"
            show-word-limit
            rows="9"
          >
          </el-input>
          <div>
            <p class="line-h">输入格式：资产名称|资产账号|资产密码|开始时间|到期时间</p>
            <p class="line-h">一行一个 如:</p>
            <p class="line-h">阿里云域名|jjyun.cc|password|2021-08-28|2022-08-28</p>
            <div class="line-but">
              <el-button
              size="small"
              type="primary"
              icon="el-icon-plus"
              @click="goTools"
              >免费转换格式</el-button
            >
            </div>
          </div>
        </el-form-item>

        <el-form-item label="续费金额" :label-width="formLabelWidth">
          <el-input
            type="text"
            v-model="formData.price"
            placeholder="请输入续费金额"
          ></el-input>
        </el-form-item>

        <!-- 上传图片 -->
        <el-form-item label="上传合同" :label-width="formLabelWidth">
          <div class="contract-list">
            <draggable class="wrapper" v-model="contractImage.image">
              <transition-group>
                <div v-for="(item, index) in contractImage.image" :key="item.file_path">
                  <div class="item">
                    <el-image
                      :src="item.file_path"
                      :preview-src-list="[item.file_path]"
                      class="img-auto"
                      >
                    </el-image>
                    <!-- <img v-img-url="item.file_path" alt="file_path"/> -->
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i class="el-icon-close"></i></a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>

        <el-form-item
          label="所属用户"
          :label-width="formLabelWidth"
        >
          <el-autocomplete
            v-model="formData.other_user_name"
            :fetch-suggestions="queryUserSearch"
            placeholder="请选择已存在的用户"
            placement="bottom"
            value-key="nickName"
            @change.native="handleUserChange"
            @select="handleUserSelect"
          ></el-autocomplete>
        </el-form-item>
      </template>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="submitApi" :loading="loading"
        >确定</el-button
      >
    </div>
    <!--商品图片组件-->
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
  </el-dialog>
</template>

<script>
import Api from "@/api/api.js";
import UserAssetApi from "@/api/userasset.js";
import myTime from "@/utils/time";
import Upload from "@/components/file/Upload";
import draggable from "vuedraggable";

export default {
  components: {
    Upload,
    draggable
  },
  data() {
    return {
      isProductUpload: false,
      srcList:[],
      contractImage: {image: []},
      formData: {
        plugin_name: "",
        other_plugin_name: null,
        sort: 50,
        begin_time: new Date().valueOf(),
        end_time: myTime.add(new Date(), 1, "y"),
        price: "",
        image: []
      },
      rules: {
        other_user_name: [
          {
            required: true,
            message: "请选择已存在的用户",
            trigger: "change"
          }
        ],
        other_plugin_name: [
          { required: true, message: "请输入已存在关联接口", trigger: "blur" }
        ],
        begin_time: [
          { required: true, message: "请选择开始时间", trigger: "blur" }
        ],
        end_time: [
          { required: true, message: "请选择结束时间", trigger: "blur" }
        ],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }]
      },
      /*左边长度*/
      formLabelWidth: "100px",
      /*是否显示*/
      dialogVisible: false,
      loading: false,
      /* 类型 */
      typeList: [],
      /* 表单Items */
      formItems: null,
      formLoading: false,
      searchOption: [],
      assets_type: "",
      assets_text: "" //文本框内容
    };
  },
  props: ["open_batchadd", "autocompleteOptions"],
  created() {
    this.init();
  },
  methods: {
    showImg(img) {
      console.log(img)
      this.srcList[0] =  img
    },
    /*打开上传图片*/
    openProductUpload: function () {
      this.isProductUpload = true;
    },
    /*上传商品图片*/
    returnProductImgsFunc(e) {
      console.log('e=>',e)
      if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        // let imgs = this.form.model.image.concat(e);
        // contractImage
        // this.$set(this.form.model, "image", imgs);
        let imgs = this.contractImage.image.concat(e);
        this.$set(this.contractImage, "image", imgs);
        this.$set(this.formData, "contract", imgs);
        this.formData.contract = this.contractImage.image;
        imgs.forEach((item,index) => {
          this.srcList[index] = item.file_path
        })
      }
      this.isProductUpload = false;
    },
    /*删除商品图片*/
    deleteImg(index) {
      // this.form.model.image.splice(index, 1);
      this.contractImage.image.splice(index, 1);
    },

    /* 初始化数据 */
    async init() {
      this.formLoading = true;
      this.dialogVisible = this.open_batchadd;
      this.searchOption = await this.getRelationshipApi();
      this.formLoading = false;
    },

    /* 获取关键数据接口 */
    async getRelationshipApi() {
      try {
        const res = await Api.getData();
        if (res.data && res.data.list && res.data.list.data) {
          return res.data.list.data.map(item => ({
            ...item,
            value: item.name
          }));
        }
      } catch (error) {}
    },

    /* 接口类型搜索功能 */
    queryTypeSearch(queryString, cb) {
      var results = queryString
        ? this.searchOption.filter(this.typeFilter(queryString))
        : this.searchOption;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 300);
    },

    /* 过滤接口类型 */
    typeFilter(queryString) {
      return state => {
        return (state.value + "").includes(queryString);
      };
    },

    /* 处理接口类型搜索，选中 */
    async handleTypeSelect(item) {
      this.formItems = [];
      this.formLoading = true;
      // this.formItems = await this.getFormItems(item.remark.plugin_name);
      this.formItems = await this.getFormItems("server");
      this.formData = this.getFormData(item);
      this.rules = this.getFormRules(this.formItems, this.rules);
      this.formLoading = false;
    },

    /* 处理接口类型搜索，改变 */
    handleTypeChange(event) {
      const value = event.target.value;
      const res = this.searchOption.find(item => item.name === value);
      if (res) {
        this.formData.plugin_name = res.remark.plugin_name;
        this.formData.api_id = res.api_id;
      } else {
        this.formData.other_plugin_name = null;
      }
    },

    /* 获取表单规则 */
    getFormRules(options = [], rules) {
      const newRules = options.reduce((acc, cur) => {
        if (cur.rules) {
          const name = cur.name;
          acc = { ...acc, [name]: cur.rules };
        }
        return acc;
      }, {});
      return { ...rules, ...newRules };
    },

    /* 获取表单子项 */
    async getFormItems(value) {
      try {
        const res = await UserAssetApi.getAddFormItems({
          plugin_name: value
        });
        return res.data || [];
      } catch (error) {}
    },

    /* 获取表单数据 */
    getFormData(item) {
      const tempFormData = this.formItems.reduce((acc, item) => {
        acc = { ...acc, [item.name]: item.defaultvalue };
        return acc;
      }, this.formData);
      tempFormData.plugin_name = item.remark.plugin_name;
      tempFormData.api_id = item.api_id;
      return tempFormData;
    },

    // 提交api表单
    submitApi() {
      this.formLoading = true;
      // console.log(this.assets_text);
      console.log(this.formData.contract);
      let formatData = {
        plugin_name: this.formData.plugin_name,
        api_id: this.formData.api_id,
        sync_type: this.formData.vhost_sync_type,
        content: this.assets_text,
        user_id: this.formData.user_id,
        contract: this.formData.contract,
        price: this.formData.price
      }
      // console.log('formatData',this.formData.contract)
      this.$emit("submitForm", formatData);
      // /index.php/shop/plus.plugins.Index/add_shops
      //   批量添加资产，POST请求
      //   参数 plugin_name  接口类型path
      //           api_id              接口id
      //           sync_type        资产类型
      //           content           资产内容
      //           user_id            所属用户id
      // this.$refs.formData.validate(valid => {
      //   if (valid) {
      //     try {
      //       const formatData = {
      //         ...this.formData,
      //         remark: { ...this.formData }
      //       };
      //      this.$emit("submitForm", formatData);
      //       this.loading = true;
      //     } catch (error) {}
      //   } else {
      //     return false;
      //   }
      // });
    },

    /*关闭弹窗*/
    dialogFormVisible() {
      this.$emit("closeDialog");
    },

    /* 搜索框功能 */
    queryUserSearch(queryString, cb) {
      const results = queryString
        ? this.autocompleteOptions.filter(this.userFilter(queryString))
        : this.autocompleteOptions;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 300);
    },

    /* 过滤用户搜索 */
    userFilter(queryString) {
      return state => {
        return state.nickName.includes(queryString);
      };
    },

    /* 处理用户搜索框，改变 */
    handleUserChange(event) {
      const value = event.target.value;
      const res = this.autocompleteOptions.find(
        item => item.nickName === value
      );
      if (res) {
        this.formData.user_id = res.user_id;
      } else {
        this.formData.other_user_name = null;
      }
    },

    /* 处理用户搜索框，选中 */
    handleUserSelect(item) {
      this.formData.user_id = item.user_id;
    },
    goTools(){
      window.open('http://jjyun.kmdmall.com/tools/asset.php');
    }
  }
};
</script>

<style scoped>
.img-auto {
  width: 100%;
  height: 100%;
}
.line-h{
  height: 18px;
  color: #999;
}
.line-but{
  margin: 10px 0;
}

.contract-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.contract-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.contract-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.contract-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.contract-list .item:hover .delete-btn {
  display: block;
}

/* .draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
} */

.contract-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.contract-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/user_asset/all/part/BatchAdd.vue